// extracted by mini-css-extract-plugin
export default {"container":"CPHfCt4jZKfuzWcxuThD","limitedWidth":"UGwgz0SlSmBd5SoHz6UQ","modal":"k4NuyQnQhJJGqCEdhV84","topPositioned":"qf1r7v9GZSyozdj4AD9w"};